import AccordionInput from './AccordionInput';

export default AccordionInput;
